module.exports = "/packs/templates.category_filter-0c2ef779.html";